module.exports = __webpack_public_path__ + "assets/adobe-experience-manager.c0135fa2.svg";